import { pipelineStagesHoverMapping } from '../../../../../constants/pipelineStagesHoverText';

const CUSTOM_STAGE_HOVER_TEXT =
  'This is a custom stage add a description so other users on your account know when to use it';

const hasDescription = (stage) => typeof stage?.description === 'string' && stage.description.trim() !== '';

export const getStageHoverText = (stage, title) => {
  if (hasDescription(stage)) return stage.description;
  return pipelineStagesHoverMapping[title.toUpperCase()] || CUSTOM_STAGE_HOVER_TEXT;
};

export const getStageFooterText = (stage, trans) => {
  if (hasDescription(stage)) return stage.description;
  return stage?.type === 'triage' ? trans('ThisStageForPursuitsYouTriaged') : '';
};
